import { IFilterState, IEvent } from "../interfaces";

/**
 * Accepts a FilterState object and returns an array of applied filter options.
 */
export function activeFilterOptions(filter: IFilterState<IEvent>): string[] {
    return filter.options.filter((f, i) => filter.selectedOptions.some(o => o === i)).map(o => o.value);
}